import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from 'app/services';
import { UntypedFormControl } from '@angular/forms';
import { merge, Subject } from 'rxjs';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';
import { unionBy, ceil } from 'lodash';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { BaseService } from 'app/_helpers/base/base.service';
import { CommercialPrintComponent } from 'app/main/commercials/components/commercial-print/commercial-print.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-wg-commercial-property-updates',
  templateUrl: './wg-commercial-property-updates.component.html',
  styleUrls: ['./wg-commercial-property-updates.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgCommercialPropertyUpdatesComponent implements OnInit, AfterViewChecked, OnDestroy {

  user: any;
  offices = [] as any;

  commercialPropertiesDataRange: UntypedFormControl = new UntypedFormControl('price_changes');
  commercialPropertiesDataPage: UntypedFormControl = new UntypedFormControl(1);
  commercialPropertiesData: any = {};
  loadingCommercialPropertiesData: boolean;
  @ViewChild('commercialPropertiesDataWidget', { static: false }) private commercialPropertiesDataWidget: ElementRef;
  comPropertyOfiices: UntypedFormControl = new UntypedFormControl('');
  comPropertyFilter = {} as any;
  commercialPropertiesWidgetChecked: boolean;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _authenticationService: AuthenticationService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private _gService: BaseService,
    private _matDialog: MatDialog,
  ) {
    this.user = this._authenticationService.currentUserValue;
    this.commercialPropertiesWidgetChecked = false;
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    if (this.user.user_role === 'admin') {
      this._gService.get(`offices?search=${undefined}&per-page=false`, 'yii').subscribe((data: any) => {
        this.offices = data;
      });
      this.comPropertyOfiices.setValue(this._authenticationService.currentOfficeValue._id);
    }

    merge(this.commercialPropertiesDataRange.valueChanges, this.commercialPropertiesDataPage.valueChanges, this.comPropertyOfiices.valueChanges)
      .pipe(
        startWith('price_changes'),
        tap(() => this.loadingCommercialPropertiesData = true),
        takeUntil(this._unsubscribeAll),
        switchMap((change: string | number) => {
          if (this.comPropertyOfiices.value) {
            this.comPropertyFilter.office = this.comPropertyOfiices.value;
          }
          if (typeof change === 'string') {
            this.commercialPropertiesDataPage.setValue(1, { emitEvent: false });
            if (this.commercialPropertiesDataWidget) {
              this.commercialPropertiesDataWidget.nativeElement.scrollTop = 0;
            }
          }
          // tslint:disable-next-line: max-line-length
          return this._gService.post(`dashboard/updated_commercial_properties?range=${this.commercialPropertiesDataRange.value}&page=${this.commercialPropertiesDataPage.value}`, this.comPropertyFilter, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        if (!this.commercialPropertiesData.docs || this.commercialPropertiesDataPage.value === 1) {
          this.commercialPropertiesData = data;
        } else {
          this.commercialPropertiesData.docs = unionBy(this.commercialPropertiesData.docs, data.docs, 'id');
        }
        this.loadingCommercialPropertiesData = false;
      }, () => this.loadingCommercialPropertiesData = false);

  }

  ViewCommercialProperty(id: any): void {
    this.router.navigateByUrl('/commercials/view/' + id);
  }
  EditCommercialProperty(id: any): void {
    this.router.navigateByUrl('/commercials/update/' + id);
  }

  emailCommercialPDF(id: any): void {
    console.log('emailCommercialPDF', id);
    this._matDialog.open(CommercialPrintComponent, {
        width: '80vw',
        panelClass: 'event-form-dialog',
        data: {
            selectedItems: [id]
        },
        disableClose: true
  });
  }

  ngAfterViewChecked(): void {
    if (!this.commercialPropertiesWidgetChecked && this.commercialPropertiesDataWidget) {
      this.commercialPropertiesDataWidget.nativeElement
        .addEventListener('scroll', (event: any) => this.widgetScroll(event, this.commercialPropertiesDataPage, this.commercialPropertiesData), true);
      this.commercialPropertiesWidgetChecked = true;
    }
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.commercialPropertiesDataWidget && this.commercialPropertiesDataWidget.nativeElement) {
      this.commercialPropertiesDataWidget.nativeElement
        .removeEventListener('scroll', (event: any) => this.widgetScroll(event, this.commercialPropertiesDataPage, this.commercialPropertiesData), true);
    }
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  widgetScroll(event: any, dataPage: UntypedFormControl, data: any): void {
    if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight && dataPage.value < ceil(data.total / data.limit)) {
      dataPage.setValue(dataPage.value + 1);
    }
  }

}
